import { captureExceptionWithContext } from "./sentry";

class ErrorManager {
	static Instance = new ErrorManager();

	Handle(error) {
		if (!error) return;

		const response = error.response || null;
		if (response && response.status === 502) return;

		const message =
      response && response.data && response.data.message
      	? response.data.message
      	: error.message || "Unhandled web error";

		captureExceptionWithContext(new Error(message), {
			axios: {
				code: error.code,
				config: error.config
					? {
						url: error.config.url,
						method: error.config.method,
						baseURL: error.config.baseURL,
						timeout: error.config.timeout,
					}
					: null,
			},
			response: response
				? {
					status: response.status,
					statusText: response.statusText,
					data: response.data,
				}
				: null,
		});
	}
}

export default ErrorManager;
